<template>
  <div class="columns">
    <div class="column is-6">
      <div class="columns no-margin-bottom">
        <div class="field column is-marginless">
          <label class="label">Voornaam</label>
          <div class="control">
            <input class="input" type="text" placeholder="Voornaam" v-model="details.firstName">
          </div>
        </div>

        <div class="field column is-marginless">
          <label class="label">Achternaam</label>
          <div class="control">
            <input class="input" type="text" placeholder="Achternaam" v-model="details.lastName">
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Email</label>
        <div class="control has-icons-left">
          <input class="input" type="text" placeholder="Email" v-model="details.email">
          <span class="icon is-small is-left">
            <i class="fa fa-envelope"></i>
          </span>
        </div>
      </div>

      <a class="button is-primary" :class="{ 'is-loading': isSavingDetails }" v-on:click="saveDetails">Opslaan</a>

      <hr>

      <div class="field">
        <label class="label">Wachtwoord veranderen</label>
        <div class="control has-icons-left">
          <input class="input" type="password" placeholder="Nieuw wachtwoord" v-model="newPassword">
          <span class="icon is-small is-left">
            <i class="fa fa-lock"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <div class="control has-icons-left">
          <input class="input" type="password" placeholder="Herhaal wachtwoord" v-model="repeatPassword">
          <span class="icon is-small is-left">
            <i class="fa fa-lock"></i>
          </span>
        </div>

        <p v-if="newPassword !== repeatPassword" class="help is-danger">Wachtwoorden zijn niet gelijk</p>
      </div>

      <div class="field">
        <div class="message is-danger is-marginless">
          <div class="message-header">
            Wachtwoord veranderen
          </div>
          <div class="message-body">
            Wanneer u het wachtwoord veranderd word u op <strong>alle</strong> ingelogde apparaten uitgelogd.
          </div>
        </div>
      </div>

      <a class="button is-danger" :class="{ 'is-loading': isSavingPassword }" v-on:click="changePassword">Wijzigen</a>
    </div>
    <div class="column is-5 is-offset-1">
      <label class="label table-padding-fix">Actieve apparaten</label>
      <table class="table is-striped">
        <thead>
          <tr>
            <th>Apparaat</th>
            <th>Aangemaakt op</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="token in tokens">
            <td>{{token.userAgent | useragent}}</td>
            <td>{{token.createdAt | timezone | date}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      details: 'userDetails',
      tokens: 'activeTokens'
    })
  },
  data () {
    return {
      newPassword: '',
      repeatPassword: '',
      isSavingDetails: false,
      isSavingPassword: false
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getUserDetails')
      await this.$store.dispatch('getActiveTokens')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de gebruikers gegevens.'
      })
    }
  },
  methods: {
    async saveDetails () {
      this.isSavingDetails = true

      await this.$store.dispatch('saveUserDetails', this.details).catch(() => {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het opslaan van de gebruikers gegevens.'
        })
      })

      this.isSavingDetails = false
    },
    async changePassword () {
      if (this.newPassword !== this.repeatPassword) {
        return
      }

      this.isSavingPassword = true

      try {
        await this.$store.dispatch('changePassword', this.newPassword)
        await this.$store.dispatch('getActiveTokens')
      } catch (error) {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het opslaan van het nieuwe wachtwoord.'
        })
      }

      this.newPassword = ''
      this.repeatPassword = ''

      this.isSavingPassword = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/algemeen.vue